require("dragula/dist/dragula.min.css")

import dragula from 'dragula';

async function saveSortOrder($container) {
  var idsInOrder = $container.find('> *').map(function(index,element) { return parseInt($(element).attr('data-id')); }).toArray();
  var parentId = $container.attr('parent-id');
  var parentAttribute = $container.attr('parent-attribute');
  var notifyParent = $container.attr('class').split(/\s+/).find(element => element === 'notify-parent')
  var result = {};
  await $.post($container.attr('data-reorder'), {ids_in_order: idsInOrder, parent_id: parentId, parent_attribute: parentAttribute, notify_old_parent: notifyParent}, function(response) {
    result = response;
    if ($container.closest('.opened-modally').length) {
      refreshModalBase();
    }
  });
  return result;
}

function enableSortable($scope) {
  setTimeout(function() {
    var selector = '[data-reorder]';
    var $reorderable = $scope.find(selector).addBack(selector);
    console.log("enabling sort on array of " + $reorderable.length);
    var containersGrouped = false;

    $reorderable.each(function (index, container) {
      var showLoader = false;
      if (container.className.split(/\s+/).find(element => element === 'show-loading')){
        showLoader = true;
      }

      var isGroup = container.className.split(/\s+/).find(element => element === 'group-reorder');
      if (isGroup && containersGrouped) {
        return;
      }

      var containers = [];
      var containerObjects = [];

      if (isGroup){
        $reorderable.each(function (index, container) {
          if( container.className.split(/\s+/).find(element => element === 'group-reorder') ){
            containers.push(container);
            containerObjects.push($(container));
          }
        });
        containersGrouped = true;
      } else {
        containers.push(container);
        containerObjects.push($(container));
      }

      // enable drag-and-drop reordering.
      var dragulaObj = dragula(containers, {
        moves: function(el, container, handle) {
          var dataTarget = container.getAttribute('data-target-query');
          if (dataTarget && !handle.matches(dataTarget)) return false;

          var $handles = $(el).find('.reorder-handle')
          if ($handles.length) {
            return !!$(handle).closest('.reorder-handle').length
          } else {
            if (!$(handle).closest('.undraggable').length) {
              return $(handle).closest('[data-reorder]')[0] == container;
            } else {
              return false;
            }
          }
        },
        accepts: function (el, target, source, sibling) {
          if ($(sibling).hasClass('undraggable') && $(sibling).prev().hasClass('undraggable')) {
            return false;
          } else {
            return true;
          }
        },
      }).on('drop', async function (el) {
        try {
          if (showLoader) {
            startLoader();
          }
          var reloadPage = false;
          // save order here.
          for (index in containerObjects) {
            var result = await saveSortOrder(containerObjects[index]);
            if (result.reload) {
              reloadPage = true;
            }
          }
          if (showLoader) {
            // endLoader();
          }
          if (reloadPage && !$(containerObjects[index]).hasClass('no-sortable-reload')) {
            location.reload();
          } else {
            const reorder = new Event('reorder');
            document.dispatchEvent(reorder);
          }
        } catch (error) {
          // endLoader();
          console.error(error);
        }
      }).on('over', function (el, container) {

        // deselect any text fields, or else things go slow!
        $(document.activeElement).blur();

      });

    });
  }, 500);
}

$(document).on('turbolinks:load', function() {
  console.log("🍩 Sortable: Enabling on <body> after a Turbolinks load.")
  enableSortable($('body'));
})

$(document).on('sprinkles:update', function(event) {
  console.log("🍩 Sortable: Enabling on the following element after a Sprinkles content update:")
  console.log(event.target);
  enableSortable($(event.target));
})
